import React, { useState } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { FaPencil } from 'react-icons/fa6';
import Dropdown from 'react-bootstrap/Dropdown';
import Button from 'react-bootstrap/Button';

const Preference = () => {
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(!show);

  const [shippingNotes, setShippingNotes] = useState('');
  const handleInputChange = (event) => {
    setShippingNotes(event.target.value);
  };

  const [isChecked, setIsChecked] = useState(false);
  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const [selectedDay, setSelectedDay] = useState('');
  const handleDayChange = (event) => {
    setSelectedDay(event.target.value);
  };

  const [selectedRam, setSelectedRam] = useState('');
  const handleRamChange = (event) => {
    setSelectedRam(event.target.value);
  };

  const [showInput, setShowInput] = useState(false);
  const handleCheckedboxChange = () => {
    setShowInput((prevState) => !prevState);
  };

  const handleClose = () => setShow(false);

  const [selectedRep, setSelectedRep] = useState('');
  const handleRepChange = (event) => {
    setSelectedRep(event.target.value);
  };

  const [selectedProcedure, setSelectedProcedure] = useState('');
  const handleProcedureChange = (event) => {
    setSelectedProcedure(event.target.value);
  };

  const inputStyle = {
    border: '2px solid #ccc',
    borderRadius: '4px',
    padding: '8px',
    width: '60px',
    height: '30px',
    marginLeft: '50px',
  };

  const inputStyling = {
    border: '2px solid #ccc',
    borderRadius: '4px',
    padding: '8px',
    width: '60px',
    height: '30px',
    marginLeft: '40px',
  };

  return (
    <div>
      <h2 style={{ backgroundColor: 'white', color: '#004aad', padding: '5px' }}>
        Shipping
      </h2>

      <div
        style={{
          alignItems: 'center',
          fontSize: '0.9rem',
          marginRight: '20px',
          gap: '50px',
          backgroundColor: '#f2f2f2',
          borderTop: '3px solid #004aad',
          padding: '10px',
          marginBottom: '10px',
        }}
      >
        {/* Default Shipper */}
        <div>
          <b
            style={{
              marginLeft: '10px',
              fontSize: '1rem',
              fontWeight: '600',
              color: '#333',
            }}
          >
            Default Shipper
          </b>
          <select
            id="procedure-select"
            value={selectedProcedure}
            onChange={handleProcedureChange}
            style={{
              height: '40px',
              fontSize: '14px',
              padding: '8px',
              width: '199px',
              border: '2px solid #ccc',
              borderRadius: '4px',
              backgroundColor: 'white',
              color: '#495057',
              cursor: 'pointer',
              marginLeft: '140px',
            }}
          >
            <option value="No Default Shipper">No Default Shipper</option>
            <option value="Local Driver">Local Driver</option>
            <option value="Royal Mail">Royal Mail</option>
            <option value="OTHER-UPS COURIER">OTHER-UPS COURIER</option>
          </select>
        </div>

        <br />

        {/* Override Transit Time */}
        <div>
          <Row className="mb-3">
            <Col>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <b
                  style={{
                    marginLeft: '10px',
                    fontSize: '1rem',
                    fontWeight: '600',
                    color: '#333',
                  }}
                >
                  Override Transit Time
                </b>
                <Form.Check
                  type="checkbox"
                  aria-label=""
                  style={{ marginLeft: '40px' }}
                  onChange={handleCheckboxChange}
                />
              </div>
            </Col>
          </Row>

          {isChecked && (
            <>
              <div>
                <b
                  style={{
                    marginLeft: '10px',
                    fontSize: '0.95rem',
                    fontWeight: '500',
                    color: '#333',
                  }}
                >
                  Inbound Transit Days
                </b>
                <input
                  type="number"
                  id="inbound-num"
                  name="inbound-num"
                  style={inputStyle}
                />
              </div>
              <br />
              <div>
                <b
                  style={{
                    marginLeft: '80px',
                    fontSize: '0.95rem',
                    fontWeight: '500',
                    color: '#333',
                  }}
                >
                  Outbound Transit Days
                </b>
                <input
                  type="number"
                  id="outbound-num"
                  name="outbound-num"
                  style={inputStyling}
                />
              </div>
            </>
          )}
        </div>

        <br />

        {/* Shipping Notes */}
        <div>
          <Row className="mb-3">
            <Col xs={12}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <b
                  style={{
                    marginLeft: '10px',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#333',
                  }}
                >
                  Shipping Notes
                </b>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={shippingNotes}
                  onChange={handleInputChange}
                  placeholder=""
                  style={{
                    width: '199px',
                    height: '60px',
                    fontSize: '14px',
                    padding: '0.90rem 1.25rem',
                    border: '2px solid #ccc',
                    marginLeft: '140px',
                  }}
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <h2 style={{ backgroundColor: 'white', color: '#004aad', padding: '5px' }}>
        Financial
      </h2>

      <div
        style={{
          alignItems: 'center',
          fontSize: '0.9rem',
          marginRight: '20px',
          gap: '50px',
          backgroundColor: '#f2f2f2',
          borderTop: '3px solid #004aad',
          padding: '10px',
          marginBottom: '10px',
        }}
      >
        <div>
          <b style={{ marginLeft: '10px', fontSize: '1.1rem', minWidth: '150px' }}>
            Price List Group
          </b>
          <span style={{ marginLeft: '85px' }}>1 Selected</span>
        </div>
        <br />
        <div style={{ display: 'flex', alignItems: 'center', gap: '80px' }}>
          <b style={{ marginLeft: '10px', fontSize: '1.1rem', minWidth: '150px' }}>
            Charge Interest
          </b>
          <Form.Check
            type="checkbox"
            aria-label="Toggle input field"
            style={{ marginLeft: '10px' }}
            onChange={handleCheckedboxChange}
          />
          <span style={{ fontStyle: 'italic', color: 'gray' }}>
            (This will override Lab Details settings)
          </span>
        </div>
        <br />

        {showInput && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginLeft: '10px' }}>
            <b style={{ fontSize: '1.1rem', minWidth: '150px' }}>Interest Rate</b>
            <input
              type="number"
              placeholder=""
              style={{
                border: '2px solid #ccc',
                borderRadius: '6px',
                padding: '10px',
                width: '120px',
                height: '40px',
                fontSize: '1rem',
              }}
            />
            <span style={{ fontSize: '1.1rem' }}>%</span>
          </div>
        )}
        <br />
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <b style={{ marginLeft: '10px', fontSize: '1.1rem', minWidth: '150px' }}>
            General Sales Rep
          </b>
          <Form.Control
            as="select"
            value={selectedRam}
            onChange={handleRamChange}
            style={{
              width: '200px',
              height: '40px',
              fontSize: '1rem',
              padding: '10px',
              marginLeft: '99px',
              borderRadius: '6px',
            }}
          >
            <option value="">Select Sales Rep</option>
            <option value="rep1">Admin SM</option>
            <option value="rep2">Hira KH</option>
            <option value="rep3">Hira Admin</option>
          </Form.Control>
        </div>
        <br />
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <b style={{ marginLeft: '10px', fontSize: '1.1rem', minWidth: '150px' }}>
            Field Sales Rep
          </b>
          <Form.Control
            as="select"
            value={selectedRep}
            onChange={handleRepChange}
            style={{
              width: '200px',
              height: '40px',
              fontSize: '1rem',
              padding: '10px',
              marginLeft: '105px',
              borderRadius: '6px',
            }}
          >
            <option value="">Select Sales Rep</option>
            <option value="rep1">Admin SM</option>
            <option value="rep2">Hira KH</option>
            <option value="rep3">Hira Admin</option>
          </Form.Control>
        </div>
        <br />
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <b style={{ marginLeft: '10px', fontSize: '1.1rem', minWidth: '150px' }}>
            Process Payment Day
          </b>
          <Form.Control
            as="select"
            value={selectedDay}
            onChange={handleDayChange}
            style={{
              width: '200px',
              height: '40px',
              fontSize: '1rem',
              padding: '10px',
              marginLeft: '70px',
              borderRadius: '6px',
            }}
          >
            <option value="">No Auto Payments</option>
            <option value="Monday">Day 1</option>
            <option value="Tuesday">Day 2</option>
            <option value="Wednesday">Day 3</option>
            <option value="Thursday">Day 4</option>
            <option value="Friday">Day 5</option>
            <option value="Saturday">Day 6</option>
            <option value="Sunday">Day 7</option>
            <option value="Monday">Day 8</option>
            <option value="Tuesday">Day 9</option>
            <option value="Wednesday">Day 10</option>
            <option value="Thursday">Day 11</option>
            <option value="Friday">Day 12</option>
            <option value="Saturday">Day 13</option>
            <option value="Sunday">Day 14</option>
            <option value="Monday">Day 15</option>
            <option value="Tuesday">Day 16</option>
            <option value="Wednesday">Day 17</option>
            <option value="Thursday">Day 18</option>
            <option value="Friday">Day 19</option>
            <option value="Saturday">Day 20</option>
            <option value="Sunday">Day 21</option>
            <option value="Sunday">Day 22</option>
            <option value="Sunday">Day 23</option>
            <option value="Sunday">Day 24</option>
            <option value="Sunday">Day 25</option>
            <option value="Sunday">Day 26</option>
            <option value="Sunday">Day 27</option>
            <option value="Sunday">Day 28</option>
            <option value="Sunday">Last Day</option>
          </Form.Control>
        </div>
        <br />
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <b style={{ marginLeft: '10px', fontSize: '1.1rem', minWidth: '150px' }}>
            Credit Limit
          </b>
          <Form.Control
            type="text"
            placeholder=""
            style={{
              width: '200px',
              height: '40px',
              fontSize: '1rem',
              padding: '10px',
              marginLeft: '103px',
              borderRadius: '6px',
            }}
          />
        </div>
        <br />
        <div>
          <Row className="mb-3">
            <Col>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <b style={{ marginRight: '15px', fontSize: '1.1rem', minWidth: '150px' }}>
                  On Hold Prepay
                </b>
                <Form.Check
                  type="checkbox"
                  aria-label=""
                  style={{
                    marginLeft: '98px',
                    width: '200px',
                    height: '40px',
                    fontSize: '1rem',
                    padding: '10px',
                    borderRadius: '6px',
                  }}
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <h2 style={{ backgroundColor: 'white', color: '#004aad', padding: '5px' }}>
        Procedures
      </h2>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          fontSize: '0.9rem',
          marginRight: '20px',
          gap: '30px',
          backgroundColor: '#f2f2f2',
          borderTop: '3px solid #004aad',
          padding: '20px',
          marginBottom: '10px',
          boxSizing: 'border-box',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <b style={{ marginLeft: '10px', fontSize: '1.1rem', minWidth: '150px' }}>
            Group
          </b>
          <select
            id="groupDropdown"
            style={{
              height: '40px',
              fontSize: '14px',
              padding: '8px',
              width: '199px',
              border: '2px solid #ccc',
              borderRadius: '4px',
              backgroundColor: 'white',
              color: '#495057',
              cursor: 'pointer',
              marginLeft: '84px',
            }}
          >
            <option value="">Select Group</option>
          </select>
        </div>
      </div>
      <br />

      <h3 style={{ backgroundColor: 'white', color: '#004aad', padding: '5px' }}>
        E-Billing
      </h3>

      <div
        style={{
          alignItems: 'center',
          fontSize: '0.9rem',
          marginRight: '20px',
          gap: '50px',
          backgroundColor: '#f2f2f2',
          borderTop: '3px solid #004aad',
          padding: '10px',
          marginBottom: '10px',
        }}
      >
        <div>
          <b style={{ marginLeft: '10px', fontSize: '1.1rem', minWidth: '150px' }}>
            Type
          </b>
          <select
            id="groupDropdown"
            style={{
              height: '40px',
              fontSize: '14px',
              padding: '8px',
              width: '199px',
              border: '2px solid #ccc',
              borderRadius: '4px',
              backgroundColor: 'white',
              color: '#495057',
              cursor: 'pointer',
              marginLeft: '210px',
            }}
          >
            <option value="OFF">OFF</option>
            <option value="Statements Only">Statements only</option>
            <option value="Statements & Invoice">Statements & Invoice</option>
          </select>
          <br />
          <br />
          <b style={{ marginLeft: '10px', fontSize: '1.1rem', minWidth: '150px' }}>
            Contacts
          </b>
          <select
            id="groupDropdown"
            style={{
              height: '40px',
              fontSize: '14px',
              padding: '8px',
              width: '199px',
              border: '2px solid #ccc',
              borderRadius: '4px',
              backgroundColor: 'white',
              color: '#495057',
              cursor: 'pointer',
              marginLeft: '176px',
            }}
          >
            <option value="Mr Ahmed Farooq">Mr Ahmed Farooq</option>
            <option value="Huma Farooq">Huma Farooq</option>
          </select>
        </div>
      </div>

      <h3 style={{ color: '#004aad', padding: '5px' }}>
        Account Tags
      </h3>

      <div
        style={{
          alignItems: 'center',
          fontSize: '0.9rem',
          marginRight: '20px',
          gap: '50px',
          backgroundColor: '#f2f2f2',
          borderTop: '3px solid #004aad',
          padding: '10px',
          marginBottom: '10px',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <b style={{ marginRight: '10px', fontSize: '1.1rem', minWidth: '150px' }}>
            Tags
          </b>
          <Dropdown show={show} onClick={handleShow} drop="end">
            <Button
              style={{
                backgroundColor: '#004aad',
                borderColor: '#004aad',
                marginLeft: '250px',
              }}
              onClick={handleShow}
            >
              <FaPencil />
            </Button>

            {show && (
              <Dropdown.Menu show style={{ fontSize: '12px' }}>
                <Dropdown.Item>a- practice</Dropdown.Item>
                <Dropdown.Item>conventry-dental</Dropdown.Item>
                <Dropdown.Item>dental-beauty</Dropdown.Item>
                <Dropdown.Item>murray-dental</Dropdown.Item>
                <Dropdown.Item>swissmeda</Dropdown.Item>
                <Dropdown.Item>bhandal</Dropdown.Item>
              </Dropdown.Menu>
            )}
          </Dropdown>
        </div>
      </div>

      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <Button
        style={{
          backgroundColor: '#004aad',
          borderColor: '#004aad',
        }}
        onClick={handleClose}
      >
        Save
      </Button>
    </div>
  );
};

export default Preference;